import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AcquiredPage } from './acquired.page';

const routes: Routes = [
  {
    path: '',
    component: AcquiredPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class AcquiredPageRoutingModule {}
